import { Params } from '@angular/router';
import { STUDENT_ROUTE } from 'app/routing-constants/student-routing.constant';

export const GAMEPLAY_ROUTE = {
  name: 'gameplay',
  route(classId: string): string[] {
    return [ ...STUDENT_ROUTE.LOGGED.route(classId), 'gameplay'];
  },

  SKILL: {
    name: 'skill/:goalId',
    route(classId: string, goalId: string): string[] {
      return [...GAMEPLAY_ROUTE.route(classId), 'skill', goalId];
    },
    queryParams(branchId: string, courseId: string): Params {
      return {
        branchid: branchId,
        courseid: courseId
      };
    }
  },

  MISSION: {
    name: 'mission/:missionId/:activityNumber',
    route(classId: string, missionId: string, activityNumber: string): string[] {
      return [...GAMEPLAY_ROUTE.route(classId), 'mission', missionId, activityNumber];
    },
    queryParams(branchId: string, courseId: string): Params {
      return {
        branchid: branchId,
        courseid: courseId
      };
    }
  }
};
